import { c as _c } from "react/compiler-runtime";
import { useMap } from "@vis.gl/react-google-maps";
import { DeckProps } from "deck.gl";
import { useEffect, useState } from "react";
import { GoogleMapsOverlay } from "@deck.gl/google-maps";
export const DeckGLOverlay = props => {
  const $ = _c(8);
  const map = useMap();
  const [overlay] = useState(_temp);
  let t0;
  let t1;
  if ($[0] !== map || $[1] !== overlay) {
    t0 = () => {
      if (!map) {
        return;
      }
      overlay.setMap(map);
      return () => {
        overlay.setMap(null);
        overlay.finalize();
      };
    };
    t1 = [map, overlay];
    $[0] = map;
    $[1] = overlay;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[4] !== overlay || $[5] !== props) {
    t2 = () => {
      overlay.setProps(props);
    };
    t3 = [overlay, props];
    $[4] = overlay;
    $[5] = props;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  return null;
};
function _temp() {
  return new GoogleMapsOverlay({
    interleaved: true
  });
}